import moment from "moment";

const ProductService = {
    getRecommendedItems: async function (productId, dateFrom, dateTo, context = null) {
        const urlRaw = '/api/public/v1/product/' + productId + '/recommended-items';

        let url = new URL(window.location.origin + urlRaw);
        if (dateFrom && dateTo) {
            url.searchParams.append('dateFrom', moment(dateFrom).format('YYYY-MM-DD'));
            url.searchParams.append('dateTo', moment(dateTo).format('YYYY-MM-DD'));
        }
        if (context) {
            url.searchParams.append('context', context);
        }

        try {
            const response = await fetch(url, {
                method: 'GET', headers: {
                    'Content-Type': 'application/json'
                },
            });

            const responseData = await response.json();
            return responseData;
        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    }
};


export default ProductService;